module.exports = __webpack_public_path__ + "static/media/using-sales-navigator-9.5f97fa4d.gif";